"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var SisDocumentDownloadComponent = /** @class */ (function (_super) {
    __extends(SisDocumentDownloadComponent, _super);
    function SisDocumentDownloadComponent(documentService, deService) {
        var _this = _super.call(this) || this;
        _this.documentService = documentService;
        _this.deService = deService;
        _this.isTemporary = false;
        _this.isReady = false;
        _this._fileType = idm_document_service_client_js_1.FileType.ORIGINAL;
        return _this;
    }
    Object.defineProperty(SisDocumentDownloadComponent.prototype, "fileType", {
        get: function () {
            return this._fileType;
        },
        set: function (value) {
            if (!value) {
                value = idm_document_service_client_js_1.FileType.ORIGINAL;
            }
            this._fileType = value;
        },
        enumerable: true,
        configurable: true
    });
    SisDocumentDownloadComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.isTemporary) {
            this.isReady = true;
            return;
        }
        zip_1.zip(this.documentService.getDocumentInfo(this.documentId), this.deService.getDocumentToken(this.categoryName, this.entityInstanceId, this.rootFieldName))
            .pipe(operators_1.mergeMap(function (data) {
            _this.documentName = data[0].name;
            return _this.documentService.getDownloadUrl(_this.documentId, data[1]);
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (url) {
            _this.url = url;
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    SisDocumentDownloadComponent.prototype.download = function () {
        if (this.isTemporary) {
            this.documentService.downloadTempDocument(this.documentId);
        }
        this.documentService.downloadDocument(this.url, this.fileType);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisDocumentDownloadComponent.prototype, "documentId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDocumentDownloadComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDocumentDownloadComponent.prototype, "rootFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisDocumentDownloadComponent.prototype, "entityInstanceId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDocumentDownloadComponent.prototype, "isTemporary", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDocumentDownloadComponent.prototype, "fileType", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDocumentDownloadComponent.prototype, "documentName", void 0);
    SisDocumentDownloadComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-document-download',
            template: "\n               <ng-container *ngIf=\"isReady\">\n                 <a (click)=\"download()\">\n                   {{documentName}}\n                 </a>\n               </ng-container>\n             ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Document',
            template: "\n                      <sis-document-download [id]=\"%{id}\" [documentId]=\"%{field}\" [fileType]=\"%{fileType}\"\n                       [isTemporary]=\"%{isTemporary}\">\n                      </sis-document-download>\n                  ",
            isFieldBound: false,
        })
        /**
         * @deprecated - use sis-document from ng-controls
         */
        ,
        __metadata("design:paramtypes", [idm_document_service_client_js_1.DocumentService,
            idm_de_service_client_js_1.DeService])
    ], SisDocumentDownloadComponent);
    return SisDocumentDownloadComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.SisDocumentDownloadComponent = SisDocumentDownloadComponent;
//# sourceMappingURL=sis-document-download.component.js.map